import { cn } from "@/lib/utils";
import { Check, Minus } from "lucide-react";

export type DayConsistency = {
  day: string;
  status: "completed" | "partial" | "missed";
};

interface WeeklyConsistencyCardProps {
  weekData: DayConsistency[];
}

export const WeeklyConsistencyCard = ({ weekData }: WeeklyConsistencyCardProps) => {
  return (
    <div className="bg-card rounded-3xl p-5 shadow-soft border">
      <h3 className="text-sm font-medium mb-4">Tu Consistencia</h3>
      
      <div className="flex justify-between gap-1">
        {weekData.map((d, i) => (
          <div key={i} className="flex flex-col items-center gap-2">
            <div className={cn(
              "w-10 h-10 rounded-xl flex items-center justify-center transition-all",
              d.status === "completed" ? "gradient-primary shadow-sm" :
              d.status === "partial" ? "bg-amber-100 border border-amber-200" :
              "bg-secondary border border-border/50"
            )}>
              {d.status === "completed" && <Check className="h-5 w-5 text-primary-foreground" />}
              {d.status === "partial" && <Minus className="h-5 w-5 text-amber-500" />}
            </div>
            <span className={cn(
              "text-[10px] font-medium uppercase tracking-wider",
              d.status === "completed" ? "text-primary" : "text-muted-foreground"
            )}>
              {d.day}
            </span>
          </div>
        ))}
      </div>
      
      <div className="mt-4 flex items-center justify-center gap-4 text-xs text-muted-foreground">
        <div className="flex items-center gap-1.5">
          <div className="w-2.5 h-2.5 rounded-sm gradient-primary" /> Completo
        </div>
        <div className="flex items-center gap-1.5">
          <div className="w-2.5 h-2.5 rounded-sm bg-amber-100 border border-amber-200" /> Parcial
        </div>
      </div>
    </div>
  );
};
